import { createFileRoute } from '@tanstack/react-router'
import { NoteEditorPage } from '@/pages/Notes/NoteEditorPage'

export const Route = createFileRoute('/notes/new')({
  component: NewNotePage,
  head: () => ({
    meta: [{ title: 'New Note — Enablar' }],
  }),
})

function NewNotePage() {
  return <NoteEditorPage />
}
